<template>
  <div class="page-contain">
    <img
      class="coupon-bg"
      src="https://sc2.hexiaoxiang.com/h5/purchase/img/coupon-bg.jpg"
      alt=""
    />
    <div v-if="coupon" class="page-bottom">
      <div v-if="displaySucMsg && !err" class="coupon-message">
        <p>领取成功</p>
      </div>
      <div v-if="err" class="coupon-message">
        <p>{{ err }}</p>
      </div>
      <div class="coupon-tip">
        <div class="info">
          <div class="time">
            <p>距过期仅剩：</p>
            <p>{{ timeLeftStr }}</p>
          </div>
          <div>
            <p class="coupon-price">{{ coupon.price }}元</p>
          </div>
        </div>
        <p class="badge">限时特惠现金劵</p>
      </div>
      <div v-if="timeLeft >= 0" class="actions">
        <button
          v-if="coupon.status != 2 && timeLeft > 0"
          class="button-go"
          @click="goShop()"
        >
          立即使用
        </button>
        <button
          v-if="coupon.status != 2 && timeLeft == 0"
          class="button-go-expired"
        >
          已过期
        </button>
        <button v-if="coupon.status == 2" class="button-go-expired">
          来晚了，已领完
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import OrderApi from "api/OrderApi";
import { updateShareConfig } from "assets/enjory.js";
import store from '../store/index';
import UserApi from 'api/UserApi';

export default {
  components: {},

  data() {
    return {
      staffid:null,
      err: null,
      timeLeft: -1,
      timeLeftStr: '',
      displaySucMsg: true,
      coupon: {},
    };
  },

  created() {
    const { id,staff } = this.$route.query;
    if (!id) {
      this.err = '数据错误';
      return;
    }

    if (!staff) {
      this.err = '数据错误,员工ID缺失';
      return;
    }
    this.staffid = staff;
    localStorage.setItem('staffId', this.staffid);
    this.actionReport();

    const visited = localStorage.getItem(`vcoupon_${id}`);
    if (visited) {
      this.displaySucMsg = false;
    }

    localStorage.setItem(`vcoupon_${id}`, 1);
    const vm = this;
    const compute = () => {
      const cur = vm.coupon.expireTime || 0;
      const now = new Date().getTime();
      const leftTime = cur - now;
      if (vm.coupon.status === 1 && cur > 0 && leftTime > 0) {
        vm.timeLeft = leftTime;
        const d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        const h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        const m = Math.floor((leftTime / 1000 / 60) % 60);
        const s = Math.floor((leftTime / 1000) % 60);
        const hour = h > 9 ? h : '0' + h;
        const min = m > 9 ? m : '0' + m;
        const sec = s > 9 ? s : '0' + s;
        vm.timeLeftStr = `${d}天${hour}小时${min}分${sec}秒`; // xx天xx小时xx分xx秒
      } else {
        vm.timeLeft = 0;
        vm.timeLeftStr = `0天0小时0分0秒`;
      }
    };
    OrderApi.getVirtualCoupon({
      id,
    }).then((res) => {
      if (res.code !== 20000) {
        this.err = '请求错误';
        return;
      }
      this.coupon = res.data;
      document.title = res.data.title;
      updateShareConfig({ title: res.data.title });

      if (this.coupon.status === 1) {
        compute();
        setInterval(compute, 1000);
      } else {
        vm.timeLeft = 0;
      }
    });
  },

  destroyed() {},

  computed: {},
  methods: {
    actionReport() {
      if (!store.state.key || store.state.key === '') {
        console.log('提示：未登录，埋点无法上报');
        return;
      }

      const { id, staff } = this.$route.query;

      const param = {
        project_type: 1,
        action_type: 25,
        biz_source: `https://${location.host}/writeshop/purchase.html#/vcoupon?staff_id=${staff}&coupon=${id}`
      };
      UserApi.actionReport(param).then(res => {
        console.log('上报: ', res);
      });
    },
    goShop() {
      console.log('go shop');

      // append param to hash path
      const dest = new URL(this.coupon.jumpUrl);
      const hash = dest.hash;
      const routeSearch = new URLSearchParams(hash.substring(hash.indexOf('?') + 1));
      routeSearch.set('vcoupon', this.coupon.id);
      routeSearch.set('staff_id', this.staffid);
      dest.hash = `${hash.substring(0, hash.indexOf('?'))}?${routeSearch.toString()}`;

      window.location.href = dest.toString();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../style/mixin.scss";
.page-contain {
  width: 100%;

  .coupon-bg {
    width: 100%;
  }
}

.page-bottom {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  color: red;
  border-radius: 10px 10px 0 0;
  box-shadow: 0px -4px 10px 1px #00000064;
  padding: 5px 0;

  .coupon-message {
    p {
      text-align: center;
      margin: 15px auto;
      font-size: 1.1rem;
    }
  }

  .coupon-tip {
    border: 1px solid red;
    border-radius: 2px;
    padding: 5px 2px;
    position: relative;
    margin: 0 10px;
    font-size: 0.6rem;

    .info {
      margin-top: 1.3rem;
      display: flex;
      font-size: 0.5rem;
      justify-content: space-evenly;
      align-items: flex-start;

      .time {
        line-height: 0.8rem;
      }

      .coupon-price {
        font-size: 1.2rem;
      }
    }

    .badge {
      color: white;
      background-color: red;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 2px 0 2px 0;
      padding: 4px;
    }
  }

  .actions {
    text-align: center;
    padding: 15px 0;
    .button-go {
      width: 90%;
      background-color: #ff580d;
      color: white;
      border-radius: 50px;
      border-color: transparent;
      font-size: 0.8rem;
      padding: 12px 0;
    }

    .button-go-expired {
      width: 90%;
      background-color: gray;
      color: white;
      border-radius: 50px;
      border-color: transparent;
      font-size: 0.8rem;
      padding: 12px 0;
    }
  }
}

/deep/ .van-button {
  padding: 0;
}
</style>
